import React from 'react';

/**
 * @typedef {object} SuccessMessageProps
 * @property {string} message
 */

/**
 * @param {SuccessMessageProps} props
 */
const SuccessMessage = props => {
  const { message } = props;

  return <p className='success-message'>{message}</p>;
};

export default SuccessMessage;
